export enum PackStatus {
  UNPUBLISHED = 'UNPUBLISHED',
  SETUP = 'SETUP',
  PUBLISHED = 'PUBLISHED',
  HIDDEN = 'HIDDEN',
}
